
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ir/governance/internal-control",
      function () {
        return require("private-next-pages/ir/governance/internal-control.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ir/governance/internal-control"])
      });
    }
  